import { React, useState, useEffect } from "react";

import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../Pages/styledElements";
import { Button, PageHeader, Table, Tooltip } from "antd";
import Iconmoon from "../IconsFiles/icon";
import SearchContainer from "../SearchBarHeader/searchBar";
import { Styled } from "../../Pages/pageStyled";
import TableShimmer from "../TableShimmer/tableShimmer";
import { HaberForm } from "../../Pages/styledElements";
import LogHeader from "./logHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { getCustomerHistoryById, searchCustomerHistory } from "../../Services/customerServices";
import moment from "moment";
import { getProductHistoryById, searchProductHistory } from "../../Services/productServices";
import { getOrderHistoryById, searchOrderHistory } from "../../Services/orderServices";
import EmptyState from "../EmptyState/emptyState";
import emptyState_Search from "../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../Assets/Images/emptyState_ConnectionAPIError.svg";
import { lengthUnit, weightUnit } from "../../Utils/Constant/MeasurementUnitList";
import { render } from "@testing-library/react";
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const LogTable = (props) => {
  const columnsHead = [
    {
      title: "Sr.No",
      width: "10%",
      align: "left",
      render: (text, record, index) => (currentPage - 1) * 10 + index + 1,
    },
    {
      title: "Change Type",
      dataIndex: "change_type",
      width: "13%",
    },
    {
      title: "Change Source",
      dataIndex: "change_source",
      width: "13%",
    },
    {
      title: "Change Description",
      dataIndex: "change_desc",
      width: "20%",
      render: (record) => <span>{record.replaceAll("#%#"," ")}</span>
    },
    {
      title: "Changed By",
      dataIndex: "changed_by",
      width: "13%",
    },
    {
      title: "Changed On",
      dataIndex: "changed_on",
      width: "13%",
      render: (text, record) => (
          <div>
            <span
              style={{
                color: " var(--para-text)",
                fontSize: "14px",
              }}
            >{record.changed_on}
            </span>
            <br/>
          <span
              style={{
                color: " var(--para-text)",
                fontSize: "14px",
              }}
            >{record.change_time}
            </span>
            </div>
      )
    },
  ];
  const [history, setHistory] = useState([]);
  const location = useLocation();
  const [tableParams, setTableParams] = useState({
    page: 1,
    size: 10,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState();
  const [loading, setLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [rendering, setRendering] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [clearSearch, setClearSearch] = useState(false);

  const onChange = (pagination) => {
    if (pageSize !== pagination.pageSize) {
      setTotalRecords(0);
      setCurrentPage(1);
    } else {
      setCurrentPage(pagination.current);
    }
    setPageSize(pagination.pageSize);
    setTableParams({
      page: pagination.current,
      size: pagination.pageSize,
    });
  };

  useEffect(() => {
    if (rendering) {
      setLoading(true);
      setTableData();
      setRendering(false);
    }
  }, [rendering]);

  useEffect(() => {
    setTableData();
  }, [tableParams])

  const refresh = () => {
    setRendering(true);
  };
  
  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] =
        "There are no records to show in this list. Add your first record to view details here";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] =
        "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);

  const setTableData = () => {
    if (location.state.customer) {
      setEmptyStateLabel("noData");
      getCustomerHistoryById(
        location.state.customer.customercode,
        tableParams
      )
        .then((resp) => {
          setLoading(false);
          setTotalRecords(resp.data.total_customers_history);
          const records = resp.data.customer_history?.map((item) => {
            return {
              change_type:
                item.change_type === "create"
                  ? "Record Created"
                  : "Property Change",
              change_source: item?.changed_by === null ? "" : `${capitalize(item.changed_by)} Edit` ,
              changed_by: item.user_name,
              changed_on: item?.updated_at ? moment(item.updated_at).format("DD MMM YYYY") : "",
              change_time: item.updated_at? new Date(item.updated_at)?.getHours()+":"+ new Date(item.updated_at)?.getMinutes() : "",
              change_desc:
                item.change_type === "create"
                  ? `New customer was created by ${item.changed_by} edit`
                  : `${Object.keys(item.new_data)[0]
                      .replaceAll("_", " ")
                      .replace(/(^\w|\s\w)/g, (m) =>
                        m.toUpperCase()
                      )} was changed from ${
                        item.old_data.dealership_date ? moment(item.old_data.dealership_date).format("DD MMM YYYY") : item.old_data[Object.keys(item.old_data)[0]]
                    } to ${ item.new_data.dealership_date ? moment(item.new_data.dealership_date).format("DD MMM YYYY") : item.new_data[Object.keys(item.new_data)[0]]} by ${
                      item.changed_by
                    } edit through property change`,
            };
          });
          setHistory(records);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    }
    if (location.state.product) {
      getProductHistoryById(location.state.product.productCode, tableParams)
        .then((resp) => {
          setLoading(false);
          setEmptyStateLabel("noData");
          setTotalRecords(resp.data.total_products_history);
          const records = resp.data.product_history?.map((item) => {
            return {
              change_type:
                item.change_type === "create"
                  ? "Record Created"
                  : "Property Change",
              change_source: item?.changed_by === null ? "" : `${capitalize(item.changed_by)} Edit`,
              changed_by: item.user_name,
              changed_on: item.updated_at? moment(item.updated_at).format("DD MMM YYYY") : "",
              change_time: item.updated_at? new Date(item.updated_at)?.getHours()+":"+ new Date(item.updated_at)?.getMinutes() : "",
              change_desc:
                item.change_type === "create"
                  ? `New product was created by ${item.changed_by} edit`
                  : `${Object.keys(item.new_data)[0]
                      .replaceAll("_", " ")
                      .replace(/(^\w|\s\w)/g, (m) =>
                        m.toUpperCase()
                      )} was changed from ${
                      (item.old_data[Object.keys(item.old_data)[0]] + " " + (item.old_data.units? (weightUnit?.hasOwnProperty(item.old_data.units?.[Object.keys(item.old_data.units)[0]]) ? capitalize(weightUnit[item.old_data.units?.[Object.keys(item.old_data.units)[0]]]?.displayName) : 
                      (lengthUnit?.hasOwnProperty(item.old_data.units?.[Object.keys(item.old_data.units)[0]]) ? 
                      lengthUnit[item.old_data.units?.[Object.keys(item.old_data.units)[0]]]?.displayName?.toUpperCase() : item.old_data.units?.[Object.keys(item.old_data.units)[0]]))  : "" )
                      // (item.old_data.units? item.old_data.units?.[Object.keys(item.old_data.units)[0]].toUpperCase() : "" )
                      )
                    } to ${(item.new_data[Object.keys(item.new_data)[0]] + " " + (item.new_data.units? (weightUnit?.hasOwnProperty(item.new_data.units?.[Object.keys(item.new_data.units)[0]]) ? capitalize(weightUnit[item.new_data.units?.[Object.keys(item.new_data.units)[0]]]?.displayName) : 
                    (lengthUnit?.hasOwnProperty(item.new_data.units?.[Object.keys(item.new_data.units)[0]]) ? lengthUnit[item.new_data.units?.[Object.keys(item.new_data.units)[0]]]?.displayName?.toUpperCase() : item.new_data.units?.[Object.keys(item.new_data.units)[0]]))  : "")
                             // (item.new_data.units? item.new_data.units?.[Object.keys(item.new_data.units)[0]].toUpperCase() : "")
                    )} by ${
                      item.changed_by
                    } edit through property change`,
            };
          });
          setHistory(records);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    }
    if (location.state.order) {
      setEmptyStateLabel("noData");
      getOrderHistoryById(
        location.state.order.orderDetails.orderno,
        tableParams
      )
        .then((resp) => {
          setLoading(false);
          setTotalRecords(resp.data.total_orders_history);
          const records = resp.data.order_history?.map((item) => {
            return {
              change_type:
                item.change_type === "create"
                  ? "Record Created"
                  :item.change_type === "state" ?
                  "State Change"
                  : "Property Change",
              change_source: item?.changed_by === null ? "" : `${capitalize(item.changed_by)} Edit`,
              changed_by: item.user_name,
              changed_on: item.updated_at? moment(item.updated_at).format("DD MMM YYYY") : "",
              change_time: item.updated_at? new Date(item.updated_at)?.getHours()+":"+ new Date(item.updated_at)?.getMinutes() : "",
              change_desc:
                item.change_type === "create"
                  ? `New order was created by ${item.changed_by} edit`
                  : `${item.new_data.quantity ? 'Rewinder Reel' : Object.keys(item.new_data)[0]
                  .replaceAll("_", " ")
                  .replace(/(^\w|\s\w)/g, (m) =>
                    m.toUpperCase()
                  ) } was changed from ${
                        item.old_data.delivery_date ? moment(item.old_data.delivery_date).format("DD MMM YYYY") : 
                        (item.old_data[Object.keys(item.old_data)[0]] + " " + (item.old_data.units? (weightUnit?.hasOwnProperty(item.old_data.units?.[Object.keys(item.old_data.units)[0]]) ? capitalize(weightUnit[item.old_data.units?.[Object.keys(item.old_data.units)[0]]]?.displayName) : 
                        (lengthUnit?.hasOwnProperty(item.old_data.units?.[Object.keys(item.old_data.units)[0]]) ? 
                        lengthUnit[item.old_data.units?.[Object.keys(item.old_data.units)[0]]]?.displayName?.toUpperCase() : item.old_data.units?.[Object.keys(item.old_data.units)[0]]))  : "" ))}
                         to ${item.new_data.delivery_date ? moment(item.new_data.delivery_date).format("DD MMM YYYY") :
                         (item.new_data[Object.keys(item.new_data)[0]] + " " + (item.new_data.units? (weightUnit?.hasOwnProperty(item.new_data.units?.[Object.keys(item.new_data.units)[0]]) ? capitalize(weightUnit[item.new_data.units?.[Object.keys(item.new_data.units)[0]]]?.displayName) : 
                         (lengthUnit?.hasOwnProperty(item.new_data.units?.[Object.keys(item.new_data.units)[0]]) ? lengthUnit[item.new_data.units?.[Object.keys(item.new_data.units)[0]]]?.displayName?.toUpperCase() : item.new_data.units?.[Object.keys(item.new_data.units)[0]]))  : ""))} by ${
                      item.changed_by 
                    } ${item.change_operation ? item.change_operation : ''} edit through ${item.change_type === 'state' ? 'state' : 'property' } change`,
            };
          });
          setHistory(records);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    }
    if (location.state.deckleOrder) {
      setEmptyStateLabel("noData");
      getOrderHistoryById(
        location.state.deckleOrder.orderDetails.orderno,
        tableParams
      )
        .then((resp) => {
          setLoading(false);
          setTotalRecords(resp.data.total_orders_history);
          const records = resp.data.order_history?.map((item) => {
            return {
              change_type:
                item.change_type === "create"
                  ? "Record Created"
                  :item.change_type === "state" ?
                  "State Change"
                  : "Property Change",
              change_source: item?.changed_by === null ? "" : `${capitalize(item.changed_by)} Edit`,
              changed_by: item.user_name,
              changed_on: item.updated_at? moment(item.updated_at).format("DD MMM YYYY") : "",
              change_time: item.updated_at? new Date(item.updated_at)?.getHours()+":"+ new Date(item.updated_at)?.getMinutes() : "",
              change_desc:
                item.change_type === "create"
                  ? `New order was created by ${item.changed_by} edit`
                  : `${item.new_data.quantity ? 'Rewinder Reel' : Object.keys(item.new_data)[0]
                  .replaceAll("_", " ")
                  .replace(/(^\w|\s\w)/g, (m) =>
                    m.toUpperCase()
                  ) } was changed from ${
                        item.old_data.delivery_date ? moment(item.old_data.delivery_date).format("DD MMM YYYY") : 
                        (item.old_data[Object.keys(item.old_data)[0]] + " " + (item.old_data.units? (weightUnit?.hasOwnProperty(item.old_data.units?.[Object.keys(item.old_data.units)[0]]) ? capitalize(weightUnit[item.old_data.units?.[Object.keys(item.old_data.units)[0]]]?.displayName) : 
                        (lengthUnit?.hasOwnProperty(item.old_data.units?.[Object.keys(item.old_data.units)[0]]) ? 
                        lengthUnit[item.old_data.units?.[Object.keys(item.old_data.units)[0]]]?.displayName?.toUpperCase() : item.old_data.units?.[Object.keys(item.old_data.units)[0]]))  : "" ))}
                         to ${item.new_data.delivery_date ? moment(item.new_data.delivery_date).format("DD MMM YYYY") :
                         (item.new_data[Object.keys(item.new_data)[0]] + " " + (item.new_data.units? (weightUnit?.hasOwnProperty(item.new_data.units?.[Object.keys(item.new_data.units)[0]]) ? capitalize(weightUnit[item.new_data.units?.[Object.keys(item.new_data.units)[0]]]?.displayName) : 
                         (lengthUnit?.hasOwnProperty(item.new_data.units?.[Object.keys(item.new_data.units)[0]]) ? lengthUnit[item.new_data.units?.[Object.keys(item.new_data.units)[0]]]?.displayName?.toUpperCase() : item.new_data.units?.[Object.keys(item.new_data.units)[0]]))  : ""))} by ${
                      item.changed_by 
                    } ${item.change_operation ? item.change_operation : ''} edit through ${item.change_type === 'state' ? 'state' : 'property' } change`,
            };
          });
          setHistory(records);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    }
  }

  const searchHistory = async (value = "") => {
    setSearchValue(value);
    if (value === "" || value === null) {
      setTableData();
    } else {
      setClearSearch(false);
      if (location.state.customer) {
        searchCustomerHistory(location.state.customer.customercode, value)
          .then((response) => {
            setLoading(false);
            setEmptyStateLabel("search");
            setTotalRecords(response?.length);
            const searchRecord = response.map((item) => {
              return {
                change_type:
                  item.change_type === "create"
                    ? "Record Created"
                    : "Property Change",
                change_source: `${capitalize(item.changed_by)} Edit`,
                changed_by: item.user_name,
                changed_on: moment(item.updated_at).format("DD MMM YYYY"),
                change_time: item.updated_at? new Date(item.updated_at)?.getHours()+":"+ new Date(item.updated_at)?.getMinutes() : "",
                change_desc:
                  item.change_type === "create"
                    ? `New customer was created by ${item.changed_by} edit`
                    : `${Object.keys(item.new_data)[0]
                      .replaceAll("_", " ")
                      .replace(/(^\w|\s\w)/g, (m) =>
                        m.toUpperCase()
                      )} was changed from ${item.old_data.dealership_date ? moment(item.old_data.dealership_date).format("DD MMM YYYY") : item.old_data[Object.keys(item.old_data)[0]]
                    } to ${item.new_data.dealership_date ? moment(item.new_data.dealership_date).format("DD MMM YYYY") : item.new_data[Object.keys(item.new_data)[0]]} by ${item.changed_by
                    } edit through property change`,
              };
            });
            setHistory(searchRecord);
          })
          .catch((error) =>
            console.log("Error in searching customers:", error),
            setEmptyStateLabel("connectionAPIError")
          );
      }
      if (location.state.product) {
        searchProductHistory(location.state.product.productCode, value)
          .then((response) => {
            setLoading(false);
            setEmptyStateLabel("noData");
            setTotalRecords(response?.length);
            const searchRecord = response.map((item) => {
              return {
                change_type:
                  item.change_type === "create"
                    ? "Record Created"
                    : "Property Change",
                change_source: `${capitalize(item.changed_by)} Edit`,
                changed_by: item.user_name,
                changed_on: moment(item.updated_at).format("DD MMM YYYY"),
                change_time: item.updated_at? new Date(item.updated_at)?.getHours()+":"+ new Date(item.updated_at)?.getMinutes() : "",
                change_desc:
                  item.change_type === "create"
                    ? `New product was created by ${item.changed_by} edit`
                    : `${Object.keys(item.new_data)[0]
                      .replaceAll("_", " ")
                      .replace(/(^\w|\s\w)/g, (m) =>
                        m.toUpperCase()
                      )} was changed from ${item.old_data[Object.keys(item.old_data)[0]]
                    } to ${item.new_data[Object.keys(item.new_data)[0]]} by ${item.changed_by
                    } edit through property change`,
              };
            });
            setHistory(searchRecord);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
            setEmptyStateLabel("connectionAPIError");
          });
      }
      if (location.state.order) {
        setLoading(false);
        setEmptyStateLabel("noData");
        searchOrderHistory(
          location.state.order.orderDetails.orderno,
          value
        )
          .then((response) => {
            setLoading(false);
            setTotalRecords(response?.length);
            const searchRecord = response.map((item) => {
              return {
                change_type:
                  item.change_type === "create"
                    ? "Record Created"
                    : item.change_type === "state" ?
                      "State Change"
                      : "Property Change",
                change_source: `${capitalize(item.changed_by)} Edit`,
                changed_by: item.user_name,
                changed_on: moment(item.updated_at).format("DD MMM YYYY"),
                change_time: item.updated_at? new Date(item.updated_at)?.getHours()+":"+ new Date(item.updated_at)?.getMinutes() : "",
                change_desc:
                  item.change_type === "create"
                    ? `New order was created by ${item.changed_by} edit`
                    : `${Object.keys(item.new_data)[0]
                      .replaceAll("_", " ")
                      .replace(/(^\w|\s\w)/g, (m) =>
                        m.toUpperCase()
                      )} was changed from ${item.old_data.delivery_date ? moment(item.old_data.delivery_date).format("DD MMM YYYY") : item.old_data[Object.keys(item.old_data)[0]]
                    } to ${item.new_data.delivery_date ? moment(item.new_data.delivery_date).format("DD MMM YYYY") : item.new_data[Object.keys(item.new_data)[0]]} by ${item.changed_by
                    } ${item.change_operation ? item.change_operation : ''} edit through ${item.change_type === 'state' ? 'state' : 'property'} change`,
              };
            });
            setHistory(searchRecord);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
            setEmptyStateLabel("connectionAPIError");
          });
      }
    }
  };

  return (
    <RightLayoutContainer>
      <TableLayoutData>
        <div className="tableDataFormat">
          <LogHeader
            title={`Change History of ${location.state.logType} ${location.state.name}`}
            data={location.state}
          />
          <SearchContainer 
            placeholder={location.state.searchText} 
            fetchOrder={searchHistory}
            clearSearch={clearSearch}
            setClearSearch={setClearSearch}
            searchedValue={searchValue}
            hideExport={true}
            />

          {loading ? (
            <TableShimmer header={columnsHead} />
          ) : history?.length ? (
            <Table
              columns={columnsHead}
              dataSource={history}
              onChange={onChange}
              pagination={{
                current: currentPage,
                total: totalRecords,
                showTitle: false,
                showTotal: (total, range) =>
                  `Showing ${range[0]}-${range[1]} of ${total} results`,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
              }}
            />
          ) : (
            <EmptyState
              img={
                emptyStateLabel === "noData" || emptyStateLabel === "filter"
                  ? emptyState_NoData
                  : emptyStateLabel === "search"
                  ? emptyState_Search
                  : emptyState_ConnectionAPIError
              }
              heading={emptyStatePropsData.heading}
              subHeading={emptyStatePropsData.subHeading}
              label={emptyStatePropsData.label}
              refresh={refresh}
            />
          )}
        </div>
      </TableLayoutData>
    </RightLayoutContainer>
  );
};
export default LogTable;
